export default {
    initCart(state, articles) {
      for(let i = 0; i < articles.length; i++){
          state.products[articles[i].id] = {
              'article_id': articles[i].id,
              'quantite': articles[i].quantite,
              'source_type': 'catalogue',
          }
      }
      localStorage.setItem('cart', JSON.stringify(state.products))
    },
    createOrUpdateProduct(state, product) {
        state.products[product.article_id] = product
        localStorage.setItem('cart', JSON.stringify(state.products))
    },
    removeProduct(state, product) {
        delete state.products[product.article_id]
        localStorage.setItem('cart', JSON.stringify(state.products))
    },
    setTotal(state, data) {
        state.total = data
    },
};
